<template>
  <div class="top">
    <img src="static/img/logo.png" alt="" />
    <div class="flex">
      <div @click="$router.push('/')">
        <span :class="{ active: num == '1' }">首页</span>
      </div>
      <div @click="$router.push('/gsintro')">
        <span :class="{ active: num == '2' }">公司介绍</span>
      </div>
      <div @click="$router.push('/cpintro')">
        <span :class="{ active: num == '3' }">产品介绍</span>
      </div>
      <div @click="$router.push('/joinus')">
        <span :class="{ active: num == '4' }">加入我们</span>
      </div>
      <div @click="$router.push('/contact')">
        <span :class="{ active: num == '5' }">联系我们</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "top",
  data() {
    return {};
  },
  props: {
    num: {
      type: String,
      default: "",
    },
  },
};
</script>
<style scoped>
.top {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 0.4375rem;
}
.top img {
  width: 1.041667rem;
  margin-right: 2.03125rem;
}
.top .flex {
  display: flex;
  font-size: 0.09375rem;
}
.flex > div {
  text-align: center;
  width: 0.729167rem;
  cursor: pointer;
}
@media screen and (max-width: 800px) {
  
    .flex > div {
      font-size: 0.15375rem;
      width: 0.9rem;
    }
}
.flex span {
  padding: 0.052083rem 0;
  display: inline-block;
}
.active {
  border-bottom: 0.026042rem solid rgb(16, 158, 163);
  color: rgb(16, 158, 163);
}
</style>


// WEBPACK FOOTER //
// src/components/top.vue